import { Box,Card, CardContent, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import CircularProgressPercentage from '../CircularProgressPercentage';
import ProgressCircle from '../ProgressCircle';
import SouthIcon from '@mui/icons-material/South';
import NorthIcon from '@mui/icons-material/North';
import { StandaloneData } from './constants';
import '../../Dashboard/dashBoard.css';
import '../progressCircle.css';
import {
	useGetDistinctFileCountMutation,
	useGetDistinctMsgCountMutation,
	useGetSAMsgCountMutation,
} from '../../../redux/dashboard/dashboard.api';
import CircularProgress from '../../../shared/components/CircularProgress';
import moment from 'moment';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'; 
import { DropdownValueContext } from '../../../shared/context/DropdownProvider';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTE_KEYS } from '../../../shared/constants/constants';

const TestFileSummary = (props) => {
	const navigate = useNavigate();
	const { dateForDashboard, messageType } = props;
	const { value, customer } = useContext(DropdownValueContext);
	const { userRole } = useSelector((state) => state?.common?.userDetails);
	const { customerId } = useSelector((state) => state?.common);
	const [getDistinctFileCount, { data }] = useGetDistinctFileCountMutation();
	const safeDateForDashboard = dateForDashboard || [];

	var payload = {
		fromDate: safeDateForDashboard.length > 0 ? moment(new Date(safeDateForDashboard[0])).format() : null,
		toDate: safeDateForDashboard.length > 1 ? moment(new Date(safeDateForDashboard[1])).format() : null,
		customerId: userRole?.name === 'Admin' || userRole?.name === 'Tester' ? customerId : customer,
		paymentServiceId: value,
	};
	useEffect(() => {
		if (customer || customerId) {
			getDistinctFileCount(payload);
		}
	}, [dateForDashboard, customer, messageType, value]);

	const handleTestcaseSelection =(status)=>{
		const properties={result:status}
		navigate(`${APP_ROUTE_KEYS.TEST_RUNS.MASTER}/ach`, {
			state: { properties }
		});
	}
	const resultData = [
				{
					resultTitle: 'Executed',
					count: data?.totalExecutedCount,
				},
				{
					resultTitle: 'Pending',
					count: data?.pendingCount,
				},
				{
					resultTitle: 'In Progress',
					count: data?.inprogressCount,
				},
				{
					resultTitle: 'Passed',
					count: data?.passedCount,
				},
				{
					resultTitle: 'Failed',
					count: data?.failedCount,
				},
	];

	return (
		<div style={{ width: '100%' }}>
			<Box
				sx={{ marginTop: '10px' }}
			>
				<Box display={'flex'} sx={{ justifyContent: 'space-between' }}>
					<Typography
						className="test-data-review"
						sx={{ fontSize: '22px',fontWeight: 600, textAlign: 'left', paddingLeft: '15px' }}
					>
						Test Batch Summary
					</Typography>
					{/* <ChevronRightIcon sx={{marginRight:'15px'}}/> */}
				</Box>

				{/* <Box sx={{justifyContent:'center',alignItems:'center',padding:'10px', display:'flex'}}> */}
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between !important',
						alignItems: 'center',
						width: '100%',
					}}
				>
					<Box sx={{ width: '100%', paddingLeft: '0px', paddingRight: '0px', marginTop: '10px' }}>
			<Card className="progress-circle-file">
				
					<CardContent style={{ display: 'flex', justifyContent: 'space-between' }}>
					{resultData?.map((pEl, index) => (
						<Box key={index}>
							<Typography style={{ fontSize: '20px', fontWeight: 400, textAlign: 'center' }}className="content-heading-executed">{pEl.resultTitle}</Typography>
							<Typography style={{ fontSize: '20px', fontWeight: 400, textAlign: 'center' }}>{pEl.count}<ArrowDownwardIcon fontSize="medium" style={{ marginLeft: 4, cursor: 'pointer' }}  onClick={() => handleTestcaseSelection(pEl.resultTitle)}/></Typography>
							 
						</Box>
					))}

				</CardContent>
				</Card>
		</Box>
				</Box>
			</Box>
		</div>
	);
};

export default TestFileSummary;
